import { Model, store } from "hybrids";

import Session from "./Session";
import UserDetails from "./UserDetails";
import User from "./User";
import { post } from "~/utils/api";

interface UserFollow {
  id: string;
  user: User;
}

async function clearDetails() {
  const session = await store.resolve(store.get(Session));
  store.clear(store.get(UserDetails, session.user.id));
}

const UserFollow: Model<UserFollow> = {
  id: true,
  user: User,
  [store.connect]: {
    async get(id) {
      const { user } = await store.resolve(store.get(Session));
      const details = await store.resolve(store.get(UserDetails, user.id));

      const followUser = details.follows.find((u) => u.id === id);
      if (followUser) {
        return {
          id: followUser.id,
          user: followUser,
        };
      }

      return null;
    },
    async set(id, values) {
      if (values) {
        await post("/follows", { id: values.user.id });
        clearDetails();
        return { ...values, id: values.user.id };
      }

      await post("/follows/delete", null, id);
      clearDetails();
      return null;
    },
  },
};

export default UserFollow;
